import JSZip from "jszip";

export function exportZip(files: { name: string; blob: Blob }[], zipName: string) {
    const zip = new JSZip();
    for (const file of files) {
        zip.file(file.name, file.blob);
    }
    zip.generateAsync({ type: "blob" }).then((content) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(content);
        link.download = zipName;
        link.click();
    });
}